export function splitFullName(fullName: string): {firstName: string; lastName: string} {
  const t = fullName.trim();
  if (!t) return {firstName: '', lastName: ''};
  const i = t.indexOf(' ');
  if (i === -1) return {firstName: t, lastName: ''};
  return {firstName: t.slice(0, i), lastName: t.slice(i + 1).trim()};
}

export function joinFullName(firstName: string, lastName: string): string {
  return [firstName.trim(), lastName.trim()].filter(Boolean).join(' ');
}

export function initialsFromParts(first: string, last: string): string {
  const a = first.trim().charAt(0);
  const b = last.trim().charAt(0);
  if (a && b) return `${a}${b}`.toUpperCase();
  if (a) return a.toUpperCase();
  if (b) return b.toUpperCase();
  return '?';
}

export function initialsFromFullName(fullName: string): string {
  const parts = splitFullName(fullName);
  return initialsFromParts(parts.firstName, parts.lastName);
}
